import { Outlet } from "react-router-dom";
import RegistrationHeader from "./header/RegistrationHeader";
import { LottieAnimation } from "../components/common/LottieAnimation";

export default function RootLayout({ showButton, showLanguageSelector }: any) {
  return (
    <>
      <RegistrationHeader showButton={showButton} showLanguageSelector={showLanguageSelector} />
      <LottieAnimation />
      <Outlet />
    </>
  );
}
